import { Tag } from 'antd';
const defCode = `
import { McGaugeChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
    @State defOption: Options = new Options({
      title: {
        show: true,
        text: '基础属性',
        right: 20,
        top: 30
      },
      series: [
        {
          data: [ { name: '鸿蒙', value: 90 } ]
        }
      ]
    })
    build() {
        Row() {
          McGaugeChart({
            options: this.defOption
          })
        }
        .height('50%')
    }
}
`

const changeCode = `
import { McGaugeChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
   @State defOption: Options = new Options({
      title: {
        show: true,
        text: '基础属性',
        right: 20,
        top: 30
      },
      series: [
        {
          data: [ { name: '鸿蒙', value: 90 } ]
        }
      ]
   })
  aboutToAppear() {
    setTimeout(() => {
      // 使用Option实例对象的setVal方法来实现，修改什么属性就传什么
      this.defOption.setVal({
        series: [
          {
            data: [ { name: '鸿蒙', value: 100 } ]
          }
        ]
      })
    }, 2000)
  }
  build() {
    Row() {
      McGaugeChart({
        options: this.defOption
      })
    }
    .height('50%')
  }
}
`

const seriesCode = `
import { McGaugeChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State detailsOption: Options = new Options({
    title: {
      show: true,
      text: 'details属性',
      right: 20,
      top: 30
    },
    series: [
      {
        data: [ { name: '鸿蒙', value: 90 } ],
        details: {
          show: true,
          offset: [0, 40],
          formatter: (dataItem: chartInterface.InterfaceObj,
           index: number) => { // 自定义文本标签
            return dataItem.name + '超出' + dataItem.value + '%'
          }
        }
      }
    ]
  })
  build() {
    Row() {
      McGaugeChart({
        options: this.detailsOption
      })
    }
    .height('50%')
  }
}
`

const gradientOption = `
import { McGaugeChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State gradientOption: Options = new Options({
    title: {
      show: true,
      text: '颜色渐变属性',
      right: 20,
      top: 30
    },
    series: [
      {
        data: [ {
          name: '鸿蒙',
          value: 90,
          gradient: ['#ffbcf3bd', '#ff99e690', '#ff80fb72']
         }
        ]
      }
    ]
  })
  build() {
    Row() {
      McGaugeChart({
        options: this.gradientOption
      })
    }
    .height('50%')
  }
}
`

const moreOption = `
import { McGaugeChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State moreOption: Options = new Options({
    title: {
      show: true,
      text: '多重仪表盘',
      right: 20,
      top: 30
    },
    series: [
      {
        arcLineWidth: 10,
        data: [
          { name: '鸿蒙', value: 89 },
          { name: 'ios', value: 50, radius: '40%' },
          { name: '安卓', value: 20, radius: '20%' }
        ],
        pointer: {
          valueIndex: 2,
          style: {
            scale: [.6, .6]
          }
        },
        details: {
          show: true,
          formatter: (dataItem: chartInterface.InterfaceObj,
           index: number) => { // 自定义文本标签
            return  dataItem.name + '超出' + dataItem.value + '%'
          },
          position: 'start',
          offset: [10, 0],
          style: {
            fontSize: 26,
            textAlign: 'left'
          }
        }
      }
    ]
  })
  build() {
    Row() {
      McGaugeChart({
        options: this.moreOption
      })
    }
    .height('50%')
  }
}
`

const roundOption = `
import { McGaugeChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State roundOption: Options = new Options({
    title: {
      show: true,
      text: '百分比环',
      right: 20,
      top: 30
    },
    series: [
      {
        startAngle: -Math.PI / 2,
        endAngle: Math.PI * 1.5,
        arcLineWidth: 25,
        data: [
          { name: '鸿蒙', value: 90,
           gradient: ['#ffbcf3bd', '#ff99e690', '#ff80fb72'] }
        ],
        axisLabel: {
          show: false
        },
        axisTick: {
          show: false
        },
        pointer: {
          show: false
        },
        dataItemStyle: {
          lineCap: 'round'
        },
        details: {
          show: true,
          formatter: (dataItem: chartInterface.InterfaceObj,
           index: number) => { // 自定义文本标签
            return  dataItem.name + '超出' + dataItem.value + '%'
          },
          style: {
            fill: '#1ed3e5',
            fontSize: 35
          }
        }
      }
    ]
  })
  build() {
    Row() {
      McGaugeChart({
        options: this.roundOption
      })
    }
    .height('50%')
  }
}
`

const moreRoundOption = `
import { McGaugeChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State moreRoundOption: Options = new Options({
    title: {
      show: true,
      text: '多组百分比环',
      right: 20,
      top: 30
    },
    series: [
      {
        startAngle: -Math.PI / 2,
        endAngle: Math.PI * 1.5,
        arcLineWidth: 10,
        data: [
          { name: '鸿蒙', value: 90 },
          { name: 'IOS', value: 80, radius: '40%' },
          { name: '安卓', value: 65,
           gradient: ['#ffbcf3bd', '#ff99e690',
            '#ff80fb72'], radius: '20%' }
        ],
        axisLabel: {
          show: false
        },
        axisTick: {
          show: false
        },
        pointer: {
          show: false
        },
        backgroundArc: {
          show: false
        },
        dataItemStyle: {
          lineCap: 'round'
        },
        details: {
          show: true,
          formatter: (dataItem: chartInterface.InterfaceObj,
           index: number) => { // 自定义文本标签
            return  dataItem.name + '超出' + dataItem.value + '%'
          },
          position: 'start',
          offset: [-10, 0],
          style: {
            fontSize: 20,
            textAlign: 'right',
          }
        }
      }
    ]
  })
  build() {
    Row() {
      McGaugeChart({
        options: this.moreRoundOption
      })
    }
    .height('50%')
  }
}
`

const columns = [
    {
        title: '名称',
        width: 180,
        dataIndex: 'name',
    },
    {
        title: '描述',
        width: 200,
        dataIndex: 'describe'
    },
    {
        title: '类型',
        dataIndex: 'type',
        render: (text) => <Tag color="orange">{text}</Tag>,
    },
    {
        title: '默认值',
        dataIndex: 'defVal'
    },
    {
        title: '必填',
        dataIndex: 'must',
        render: (text) => <Tag color="#2db7f5">{!text ? '否' : '是'}</Tag>,
    },
    {
        title: '备注',
        dataIndex: 'remarks'
    }
];

const commonData = [
    {
        name: 'grid',
        describe: '直角坐标系内绘图网格',
        type: 'Object',
        defVal: '{}',
        state: '',
        remarks: '用于设置上下左右四个边距，替代历史的cPaddingL、cPaddingT、cPaddingR、cPaddingB四个属性，不过最新版本也会兼容旧的使用方式',
        children: [
            {
                name: 'left',
                describe: '图表内容区距离左侧位置',
                type: 'String | Number',
                defVal: '10%',
                remarks: '',
            },
            {
                name: 'right',
                describe: '图表内容区距离右侧位置',
                type: 'String | Number',
                defVal: '8%',
                remarks: '',
            },
            {
                name: 'top',
                describe: '图表内容区距离顶部位置',
                type: 'String | Number',
                defVal: '40',
                remarks: '',
            },
            {
                name: 'bottom',
                describe: '图表内容区距离底部位置',
                type: 'String | Number',
                defVal: '30',
                remarks: '',
            }
        ]
    },
    {
        name: 'color',
        describe: '调色盘颜色列表',
        type: 'String[]',
        defVal: "['#296DFF', '#ff5495fd', '#ff1acffd', '#ff72e4fd', '#7B72F7', '#F85758', '#FFBF29', '#D1E9F9', '#F5FAFC', '#5A657A']",
        remarks: '',
    },
    {
        name: 'title',
        describe: '标题组件与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        state: '',
        children: [
            {
                name: 'show',
                describe: '控制标题显示与隐藏',
                type: 'Boolean',
                defVal: 'true',
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                name: 'text',
                describe: '主标题文本，支持使用 \n 换行。',
                type: 'String',
                defVal: '',
                remarks: '',
            },
            {
                name: 'subtext',
                describe: '副标题文本，支持使用 \n 换行。',
                type: 'String',
                defVal: '',
                remarks: '',
            },
            {
                name: 'itemGap',
                describe: '主副标题之间的间距。',
                type: 'Number',
                defVal: "5",
                remarks: '',
            },
            {
                key: 69,
                name: 'left',
                describe: '标题左侧位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 70,
                name: 'right',
                describe: '标题右侧位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 71,
                name: 'top',
                describe: '标题顶部位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 72,
                name: 'bottom',
                describe: '标题底部位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 73,
                name: 'offset',
                describe: '标题偏移量',
                type: 'Array',
                defVal: '[0, -20]',
                state: '',
                remarks: '用于设置标题相对于默认位置的偏移量，第一个值为X轴偏移，第二个值为Y轴偏移。'
            },
            {
                key: 2,
                name: 'textStyle',
                describe: '文本样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 21,
                        name: 'color',
                        describe: '字体颜色',
                        type: 'String',
                        defVal: "#333",
                        remarks: '支持RGB、RGBA、十六进制格式',
                    },
                    {
                        key: 22,
                        name: 'fontSize',
                        describe: '字体大小',
                        type: 'Number',
                        defVal: "18",
                        remarks: '',
                    },
                    {
                        key: 23,
                        name: 'fontWeight',
                        describe: '字体粗细',
                        type: 'String',
                        defVal: "normal",
                        remarks: '',
                    },
                    {
                        key: 25,
                        name: 'fontFamily',
                        describe: '字体样式',
                        type: 'String',
                        defVal: "sans-serif",
                        remarks: '',
                    },
                    {
                        key: 74,
                        name: 'textAlign',
                        describe: '文本对齐方式',
                        type: 'String',
                        defVal: "'center'",
                        state: '',
                        remarks: '可以设置为 "left"、"center" 或 "right"，分别表示左对齐、居中对齐和右对齐。'
                    },
                    {
                        key: 75,
                        name: 'textBaseline',
                        describe: '文本基线对齐方式',
                        type: 'String',
                        defVal: "'bottom'",
                        state: '',
                        remarks: '可以设置为 "top"、"middle" 或 "bottom"，分别表示顶部对齐、中部对齐和底部对齐。'
                    }
                ]
            },
            {
                key: 3,
                name: 'subtextStyle',
                describe: '文本样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 31,
                        name: 'color',
                        describe: '字体颜色',
                        type: 'String',
                        defVal: "#aaa",
                        remarks: '支持RGB、RGBA、十六进制格式',
                    },
                    {
                        key: 32,
                        name: 'fontSize',
                        describe: '字体大小',
                        type: 'Number',
                        defVal: "12",
                        remarks: '',
                    },
                    {
                        key: 33,
                        name: 'fontWeight',
                        describe: '字体粗细',
                        type: 'String',
                        defVal: "normal",
                        remarks: '',
                    },
                    {
                        key: 35,
                        name: 'fontFamily',
                        describe: '字体样式',
                        type: 'String',
                        defVal: "sans-serif",
                        remarks: '',
                    },
                    {
                        key: 76,
                        name: 'textAlign',
                        describe: '文本对齐方式',
                        type: 'String',
                        defVal: "'center'",
                        state: '',
                        remarks: '可以设置为 "left"、"center" 或 "right"，分别表示左对齐、居中对齐和右对齐。'
                    },
                    {
                        key: 77,
                        name: 'textBaseline',
                        describe: '文本基线对齐方式',
                        type: 'String',
                        defVal: "'bottom'",
                        state: '',
                        remarks: '可以设置为 "top"、"middle" 或 "bottom"，分别表示顶部对齐、中部对齐和底部对齐。'
                    }
                ]
            }
        ],
        remarks: '详细默认值请查看title属性讲解',
    },
    {
        name: 'animation',
        describe: '是否开启动画。',
        type: 'Boolean',
        defVal: "true",
        state: '',
        remarks: '如果频繁更新数据建议将该属性设置为false',
    },
    {
        name: 'series',
        describe: '区域样式与功能配置',
        type: 'Object[]',
        defVal: "[ ... ]",
        must: true,
        remarks: '详细默认值请查看series属性讲解',
    }
];

const seriesData = [
    {
        key: 2,
        name: 'show',
        describe: '是否显示仪表盘',
        type: 'Boolean',
        defVal: 'true',
        remarks: '控制仪表盘的整体显示状态。'
    },
    {
        key: 3,
        name: 'name',
        describe: '图例名称',
        type: 'String',
        defVal: "''",
        remarks: '定义仪表盘的图例名称。'
    },
    {
        key: 4,
        name: 'radius',
        describe: '仪表盘半径',
        type: 'String | Number',
        defVal: "'60%'",
        remarks: '设置仪表盘的半径，可以是百分比或者固定数值。'
    },
    {
        key: 5,
        name: 'center',
        describe: '仪表盘中心点',
        type: 'Array',
        defVal: "['50%', '50%']",
        remarks: '定义仪表盘中心的位置，接受两个值分别代表横纵坐标。'
    },
    {
        key: 6,
        name: 'startAngle',
        describe: '仪表盘起始角度',
        type: 'Number',
        defVal: "-(Math.PI / 4) * 5",
        remarks: '设置仪表盘起始的角度，单位为弧度。'
    },
    {
        key: 7,
        name: 'endAngle',
        describe: '仪表盘结束角度',
        type: 'Number',
        defVal: "Math.PI / 4",
        remarks: '设置仪表盘结束的角度，单位为弧度。'
    },
    {
        key: 8,
        name: 'min',
        describe: '仪表盘最小值',
        type: 'Number',
        defVal: '0',
        remarks: '设置仪表盘的最小值。'
    },
    {
        key: 9,
        name: 'max',
        describe: '仪表盘最大值',
        type: 'Number',
        defVal: '100',
        remarks: '设置仪表盘的最大值。'
    },
    {
        key: 10,
        name: 'splitNum',
        describe: '仪表盘分割数量',
        type: 'Number',
        defVal: '5',
        remarks: '定义仪表盘的分割数量。'
    },
    {
        key: 11,
        name: 'data',
        describe: '仪表盘图表数据',
        type: 'Array',
        defVal: "[]",
        remarks: '仪表盘的数据源数组。'
    },
    {
        key: 12,
        name: 'dataItemStyle',
        describe: '数据项弧线默认样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '配置仪表盘数据项的弧线样式。',
        children: [
            {
                key: 121,
                name: 'arcLineWidth',
                describe: '仪表盘弧线宽度',
                type: 'Number',
                defVal: '15',
                remarks: '设置仪表盘弧线的宽度。'
            },
            {
                key: 122,
                name: 'color',
                describe: '仪表盘弧线颜色',
                type: 'String',
                defVal: "''",
                remarks: '设置仪表盘弧线的颜色。支持RGB、RGBA、十六进制格式。'
            },
            {
                key: 123,
                name: 'lineCap',
                describe: '仪表盘弧线指定线段末端的绘制方式',
                type: 'String',
                defVal: "'butt'",
                remarks: '设置仪表盘弧线指定线段末端的绘制方式。可选值为 "butt", "round", "square"。'
            }
        ]
    },
    {
        key: 13,
        name: 'axisTick',
        describe: '轴刻度配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '设置轴刻度的显示状态、长度及样式。',
        children: [
            {
                key: 131,
                name: 'show',
                describe: '是否显示轴刻度',
                type: 'Boolean',
                defVal: 'true',
                remarks: '控制轴刻度的显示状态。'
            },
            {
                key: 132,
                name: 'tickLength',
                describe: '轴刻度长度',
                type: 'Number',
                defVal: '6',
                remarks: '设置轴刻度的长度。'
            },
            {
                key: 133,
                name: 'style',
                describe: '轴刻度默认样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '配置轴刻度的默认样式。',
                children: [
                    {
                        key: 1331,
                        name: 'color',
                        describe: '轴刻度颜色',
                        type: 'String',
                        defVal: "'#999'",
                        remarks: '设置轴刻度的颜色。支持RGB、RGBA、十六进制格式。'
                    },
                    {
                        key: 1332,
                        name: 'width',
                        describe: '轴刻度宽度',
                        type: 'Number',
                        defVal: '1',
                        remarks: '设置轴刻度的宽度。'
                    }
                ]
            }
        ]
    },
    {
        key: 14,
        name: 'axisLabel',
        describe: '轴标签配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '配置轴标签的显示状态、数据、格式化方式、与轴刻度的距离及样式。',
        children: [
            {
                key: 141,
                name: 'show',
                describe: '是否显示轴标签',
                type: 'Boolean',
                defVal: 'true',
                remarks: '控制轴标签的显示状态。'
            },
            {
                key: 142,
                name: 'data',
                describe: '轴标签数据（可以自动计算）',
                type: 'Array',
                defVal: "[]",
                remarks: '轴标签的数据源数组。'
            },
            {
                key: 143,
                name: 'formatter',
                describe: '轴标签格式化',
                type: 'String | Function',
                defVal: 'null',
                remarks: '设置轴标签的格式化方式。支持字符串模板和回调函数。'
            },
            {
                key: 144,
                name: 'labelGap',
                describe: '标签与轴刻度之间的间距',
                type: 'Number',
                defVal: '5',
                remarks: '设置标签与轴刻度之间的距离。'
            },
            {
                key: 145,
                name: 'style',
                describe: '轴标签默认样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '配置轴标签的默认样式。',
                children: [
                    {
                        key: 1451,
                        name: 'color',
                        describe: '轴标签字体颜色',
                        type: 'String',
                        defVal: "'#999'",
                        remarks: '设置轴标签的字体颜色。支持RGB、RGBA、十六进制格式。'
                    },
                    {
                        key: 1452,
                        name: 'fontSize',
                        describe: '轴标签字体大小',
                        type: 'Number',
                        defVal: '24',
                        remarks: '设置轴标签的字体大小。'
                    }
                ]
            }
        ]
    },
    {
        key: 15,
        name: 'pointer',
        describe: '指针配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '设置指针的显示状态、对应的数据值索引及样式。',
        children: [
            {
                key: 151,
                name: 'show',
                describe: '是否显示指针',
                type: 'Boolean',
                defVal: 'true',
                remarks: '控制指针的显示状态。'
            },
            {
                key: 152,
                name: 'valueIndex',
                describe: '指针对应的数据值索引',
                type: 'Number',
                defVal: '0',
                remarks: '设置指针对应的数据值索引。'
            },
            {
                key: 153,
                name: 'style',
                describe: '指针默认样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '配置指针的默认样式。',
                children: [
                    {
                        key: 1531,
                        name: 'scale',
                        describe: '指针缩放大小',
                        type: 'Array<Number>',
                        defVal: "[1, 1]",
                        remarks: '设置指针的缩放大小。'
                    },
                    {
                        key: 1532,
                        name: 'color',
                        describe: '指针颜色',
                        type: 'String',
                        defVal: "'#FF4647'",
                        remarks: '设置指针的颜色。支持RGB、RGBA、十六进制格式。'
                    }
                ]
            }
        ]
    },
    {
        key: 16,
        name: 'details',
        describe: '数据项弧线细节配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '配置仪表盘细节显示状态、格式化方式、位置偏移、值的小数精度、位置及样式。',
        children: [
            {
                key: 161,
                name: 'show',
                describe: '是否显示细节',
                type: 'Boolean',
                defVal: 'false',
                remarks: '控制细节的显示状态。'
            },
            {
                key: 162,
                name: 'formatter',
                describe: '细节格式化',
                type: 'String | Function',
                defVal: 'null',
                remarks: '设置细节的格式化方式。支持字符串模板和回调函数。'
            },
            {
                key: 163,
                name: 'offset',
                describe: '细节位置偏移',
                type: 'Array',
                defVal: "[0, 0]",
                remarks: '设置细节位置的偏移量。'
            },
            {
                key: 164,
                name: 'valueToFixed',
                describe: '值的小数精度',
                type: 'Number',
                defVal: '0',
                remarks: '设置值的小数精度。'
            },
            {
                key: 165,
                name: 'position',
                describe: '细节位置',
                type: 'String',
                defVal: "'center'",
                remarks: '设置细节的位置。可选值为 "start", "center", "end"。'
            },
            {
                key: 166,
                name: 'style',
                describe: '细节默认样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '配置细节的默认样式。',
                children: [
                    {
                        key: 1661,
                        name: 'fontSize',
                        describe: '字体大小',
                        type: 'Number',
                        defVal: '40',
                        remarks: '设置细节的字体大小。'
                    },
                    {
                        key: 1662,
                        name: 'fontWeight',
                        describe: '字体粗细',
                        type: 'String',
                        defVal: "'bold'",
                        remarks: '设置细节的字体粗细。'
                    },
                    {
                        key: 1663,
                        name: 'textAlign',
                        describe: '文本对齐方式',
                        type: 'String',
                        defVal: "'center'",
                        remarks: '设置细节的文本对齐方式。'
                    },
                    {
                        key: 1664,
                        name: 'textBaseline',
                        describe: '基线对齐方式',
                        type: 'String',
                        defVal: "'middle'",
                        remarks: '设置细节的基线对齐方式。'
                    },
                    {
                        key: 1665,
                        name: 'color',
                        describe: '字体颜色',
                        type: 'String',
                        defVal: "''",
                        remarks: '设置细节的字体颜色。支持RGB、RGBA、十六进制格式。'
                    }
                ]
            }
        ]
    },
    {
        key: 17,
        name: 'backgroundArc',
        describe: '仪表盘背景弧线配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '控制仪表盘背景弧线的显示状态及样式。',
        children: [
            {
                key: 171,
                name: 'show',
                describe: '是否显示背景弧线',
                type: 'Boolean',
                defVal: 'true',
                remarks: '控制背景弧线的显示状态。'
            },
            {
                key: 172,
                name: 'style',
                describe: '背景弧线默认样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '配置背景弧线的默认样式。',
                children: [
                    {
                        key: 1721,
                        name: 'color',
                        describe: '背景弧线颜色',
                        type: 'String',
                        defVal: "'#e0e0e0'",
                        remarks: '设置背景弧线的颜色。支持RGB、RGBA、十六进制格式。'
                    }
                ]
            }
        ]
    }
];


const anchorItems = [
    {
        key: '1',
        href: '#gradientOption',
        title: '渐变色模式',
    },
    {
        key: '2',
        href: '#moreOption',
        title: '多组仪表盘模式',
    },
    {
        key: '3',
        href: '#roundOption',
        title: '环形图模式'
    },
    {
        key: '4',
        href: '#moreRoundOption',
        title: '多组环形图模式'
    }
]

export {
    defCode,
    changeCode,
    seriesCode,
    gradientOption,
    moreOption,
    roundOption,
    moreRoundOption,
    columns,
    commonData,
    seriesData,
    anchorItems
}
